export default __webpack_public_path__ + "static/media/cancelled.ed3a1c98.svg";